import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import Header from './global/Header';
import MainMenu from './global/MainMenu';

const AppRoutes = ({
  user = null,
  component: Component,
  path,
  isPrivate,
  showHeader = true,
  showMenu = true,
  ...rest
}) => {
  return (
    <Route
      path={path}
      render={props =>
        isPrivate && !Boolean(user) ? (
          <Redirect to={{ pathname: '/login' }} />
        ) : (
          <>
            {showHeader && <Header />}
            <Component {...props} />
            {showMenu && <MainMenu />}
          </>
        )
      }
      {...rest}
    />
  );
};

export default AppRoutes;
